import React from 'react';
import { useNavigate } from 'react-router-dom';

const Test_Templete = () => {
  const navigate = useNavigate();
  return (
    <div className="pt-8 bg-[#FFF5E1] min-h-screen">
      {/* 헤더 */}
      <header className="bg-[#FFF5E1] px-6 text-center">
        <h1 className="text-5xl font-bold text-gray-800 mb-4 leading-tight">
          시니어랑 함께 <span className="text-orange-500">교육</span>을 찾아보세요
        </h1>
        <p className="text-xl text-gray-600 mb-8">
          다양한 종류의 교육 정보를 쉽게 찾아보고 지원할 수 있어요.
        </p>
        {/* 검색창 */}
        <div className="mt-6 flex justify-center max-w-3xl mx-auto mb-6">
          <div className="relative w-full">
            <input
              type="text"
              placeholder="원하는 교육을 입력하세요..."
              className="w-full px-8 py-4 border-2 border-orange-300 rounded-full text-lg focus:outline-none focus:border-orange-500 shadow-lg"
            />
            <button className="absolute right-2 top-1/2 -translate-y-1/2 bg-orange-500 text-white px-8 py-2 rounded-full text-lg hover:bg-orange-600 transition-colors">
              검색
            </button>
          </div>
        </div>
      </header>
      {/* 사이트 이용안내 */}
      <div className="mb-10"></div>
      {/* 메인 컨텐츠 */}
      <main className="max-w-7xl mx-auto px-4">
        <div className="bg-white rounded-2xl shadow p-8">
          {/* 카테고리 */}
          <section className="mb-20">
            <h2 className="text-3xl font-semibold text-gray-800 mb-8 text-center">교육 카테고리별 보기</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* 지역별 교육 */}
              <div className="bg-white p-6 rounded-xl shadow-md border border-orange-100 transition hover:shadow-lg hover:scale-105">
                <h3 className="text-xl font-bold mb-4 text-orange-500">대전 지역 교육</h3>
                <div className="flex flex-wrap gap-3">
                  {['동구', '서구', '중구', '유성구', '대덕구'].map((area) => (
                    <span
                      key={area}
                      className="bg-orange-50 px-4 py-2 rounded-full text-gray-700 hover:bg-orange-200 cursor-pointer transition-colors border border-orange-100"
                    >
                      {area}
                    </span>
                  ))}
                </div>
              </div>

              {/* 테마별 교육 */}
              <div className="bg-white p-6 rounded-xl shadow-md border border-blue-100 transition hover:shadow-lg hover:scale-105">
                <h3 className="text-xl font-bold mb-4 text-blue-500">테마별 교육</h3>
                <div className="flex flex-wrap gap-3">
                  {['취미', '자격증', '디지털 교육', '건강 교육', '봉사', '문화활동'].map((theme) => (
                    <span
                      key={theme}
                      className="bg-blue-50 px-4 py-2 rounded-full text-gray-700 hover:bg-blue-100 cursor-pointer transition-colors border border-blue-100"
                    >
                      {theme}
                    </span>
                  ))}
                </div>
              </div>

              {/* 대상별 교육 */}
              <div className="bg-white p-6 rounded-xl shadow-md border border-green-100 transition hover:shadow-lg hover:scale-105">
                <h3 className="text-xl font-bold mb-4 text-green-500">노인 대상 교육</h3>
                <div className="flex flex-wrap gap-3">
                  {[
                    '60대 이상',
                    '노인 건강교육',
                    '치매 예방교육',
                    '노인 취미교육',
                    '노인 디지털교육',
                    '노인 운동교육'
                  ].map((target) => (
                    <span
                      key={target}
                      className="bg-green-50 px-4 py-2 rounded-full text-gray-700 hover:bg-green-100 cursor-pointer transition-colors border border-green-100"
                    >
                      {target}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* 인기 교육종류 */}
          <section className="mb-16">
            <h2 className="text-3xl font-semibold text-gray-800 mb-8 text-center">인기 교육종류</h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
              {['놀이체육', '언어교육', '헬스교육', '코딩교육'].map((cat, idx) => (
                <div
                  key={cat}
                  className={`bg-gradient-to-br from-white to-gray-50 border border-gray-200 p-6 rounded-2xl shadow-sm text-center text-lg font-semibold text-gray-800 hover:shadow-lg hover:-translate-y-1 transition-all duration-200`}
                >
                  {cat}
                </div>
              ))}
            </div>
          </section>

          {/* 교육 공고 */}
          <section className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-semibold text-gray-800 mb-8 text-center">교육 공고</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {[
                {
                  Image: '/cropped_logo_1.png',
                  title: '대전평생교육진흥원: 놀이체육',
                  desc: '일자: 2025.04.12 ~ 2025.10.5',
                  extra: '스포츠스태킹 활동 중심의 참여형 프로그램으로 구성되어 있습니다.'
                },
                {
                  Image: '/cropped_logo_2.png',
                  title: '대전노인복지관: 영어교육',
                  desc: '일자: 2025.04.15 ~ 2025.10.10',
                  extra: '회화용 영어 교육 중심의 참여형 프로그램으로 구성되어 있습니다.'
                },
                {
                  Image: '/cropped_logo_3.png',
                  title: '서구노인복지관: 코딩교육',
                  desc: '일자: 2025.04.20 ~ 2025.10.15',
                  extra: '기초 파이썬 언어 교육 중심의 참여형 프로그램으로 구성되어 있습니다.'
                },
                {
                  Image: '/cropped_logo_4.png',
                  title: '대덕구노인종합복지관: 댄스교육',
                  desc: '일자: 2025.03.20 ~ 2025.09.05',
                  extra: '댄스 교육 중심의 참여형 프로그램으로 구성되어 있습니다.'
                },
                {
                  Image: '/cropped_logo_3.png',
                  title: '서구노인복지관: 놀이체육',
                  desc: '일자: 2025.04.12 ~ 2025.10.5',
                  extra: ' 스포츠스태킹 활동 중심의 참여형 프로그램으로 구성되어 있습니다.'
                },
                {
                  Image: '/cropped_logo_1.png',
                  title: '대전평생교육진흥원: 노래교육',
                  desc: '일자: 2025.04.12 ~ 2025.10.5',
                  extra: ' 스포츠스태킹 활동 중심의 참여형 프로그램으로 구성되어 있습니다.'
                },
                {
                  Image: '/cropped_logo_4.png',
                  title: '대덕구노인종합복지관: 놀이체육',
                  desc: '일자: 2025.04.12 ~ 2025.10.5',
                  extra: ' 스포츠스태킹 활동 중심의 참여형 프로그램으로 구성되어 있습니다.'
                },
                {
                  Image: '/cropped_logo_1.png',
                  title: '대전평생교육진흥원: 코딩교육',
                  desc: '일자: 2025.04.12 ~ 2025.10.5',
                  extra: '기초 자바 언어 교육 중심의 생산형 프로그램으로 구성되어 있습니다.'
                },
                {
                  title: '평생교육원: 코딩교육',
                  desc: '일자: 2025.04.22',
                },
                {
                  title: '평생교육원: 코딩교육',
                  desc: '일자: 2025.04.22',
                },
                {
                  title: '평생교육원: 코딩교육',
                  desc: '일자: 2025.04.22',
                },
                {
                  title: '평생교육원: 코딩교육',
                  desc: '일자: 2025.04.22',
                },
              ].map((step, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-xl border border-gray-200 shadow-md hover:shadow-xl transition-all hover:-translate-y-1 overflow-hidden cursor-pointer"
                  onClick={() => navigate(`/announcement/${idx + 1}`)}
                >
                  {step.Image && (
                    <div className="bg-gray-50 p-4">
                      <img
                        src={step.Image}
                        alt="로고"
                        className="w-[80%] mx-auto h-28 object-contain"
                      />
                    </div>
                  )}
                  <div className="p-6">
                    <div className="text-xl font-semibold text-gray-800 mb-2">{step.title}</div>
                    <div className="text-base text-gray-600 mb-3">{step.desc}</div>
                    {step.extra && (
                      <div className="text-sm text-gray-500">{step.extra}</div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Test_Templete;
